<template>
  <div id="app">
    <app-nav v-if="showNav"></app-nav>
    <router-view class="page"/>
  </div>
</template>

<script>
import AppNav from '@/components/AppNav.vue'

export default {
  components: {
    AppNav
  },
  computed: {
    showNav() {
      return this.$route.name && this.$route.name != 'login'
    }
  }
}
</script>


<style lang="scss">
@import '~normalize.scss/normalize';
@import './assets/scss/base.scss';
@import './assets/fonts/fonts.css';

body {
  background-color: #EBEBEB;
}
#app {
  font-family: 'Omnes', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0B0F4D;
  background-color: #EBEBEB;
  display: flex;
  min-height: 100%;
  // overflow: hidden;
  // height: 100%;

  .page {
    flex: 1;
    padding: 40px 50px 40px 145px;
    transition: padding-left 300ms;
  }
}
</style>
